var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.uri}},[_c('v-btn',{staticClass:"goback mx-2 darken-3",attrs:{"fab":"","dark":"","small":"","color":"orange"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-arrow-left")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }